import Color from "../../api/model/colors/Color";
import Gradient from "../../api/model/snapshots/layers/Gradient";
import { TransformedGradient } from "../../model/transform";

function colorEquals(color?: Color, otherColor?: Color) {
    if (!color && !otherColor) {
        return true;
    }

    if (
        (color && !otherColor) ||
        (!color && otherColor)
    ) {
        return false;
    }

    return color!.r === otherColor!.r &&
        color!.g === otherColor!.g &&
        color!.b === otherColor!.b &&
        color!.a === otherColor!.a;
}

function gradientEquals(gradient: Gradient, otherGradient: Gradient) {
    const { colorStops } = gradient;
    const { colorStops: otherColorStops } = otherGradient;

    if (
        gradient.type !== otherGradient.type ||
        colorStops.length !== otherColorStops.length
    ) {
        return false;
    }

    for (let i = 0; i < colorStops.length; i++) {
        const colorStop = colorStops[i];
        const otherColorStop = otherColorStops[i];

        if (
            colorStop.position !== otherColorStop.position ||
            !colorEquals(colorStop.color, otherColorStop.color)
        ) {
            return false;
        }
    }

    return true;
}

function transformedGradientEquals(gradient: TransformedGradient, otherGradient: TransformedGradient) {
    const { colorStops } = gradient;
    const { colorStops: otherColorStops } = otherGradient;

    if (colorStops.length !== otherColorStops.length) {
        return false;
    }

    for (let i = 0; i < colorStops.length; i++) {
        const colorStop = colorStops[i];
        const otherColorStop = otherColorStops[i];
        if (
            colorStop.position !== otherColorStop.position ||
            !colorEquals(colorStop.color.value, otherColorStop.color.value)
        ) {
            return false;
        }
    }

    return true;
}

export { colorEquals, gradientEquals, transformedGradientEquals };
